import fintrack from "../assets/fintrack.webp";
import dreamsnap from "../assets/dreamsnap.webp";
import movies from "../assets/movies.webp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";
import { Briefcase, Home, Mail, User } from "lucide-react";

export const projects = [
  {
    name: "FinTrack",
    image: fintrack,
    creator: "Davor Koteski",
    date: "Jan 6, 2026",
    description: `Fintrack is a responsive personal finance app built with React and Vite, styled using Tailwind CSS.
    It helps users in managing expenses, transactions, and budgeting while receiving personalized AI-driven insights to improve financial habits.
    Optimized with Redux, localStorage, and indexedDB, Fintrack provides high performance and strong privacy by keeping all the data stored locally.`,
    tags: ["React", "Vite", "TypeScript", "Tailwind", "Redux", "IndexedDB", "Chart.js",],
    codeLink: "https://github.com/Koteskidavor/FinTrack",
    liveLink: "https://fintrackcash.netlify.app/",
    route: "FinTrack",
  },
  {
    name: "Movies",
    image: movies,
    creator: "Davor Koteski",
    date: "Jun 13, 2026",
    description: `Movies is a mobile-responsive movie and TV show platform using React.js with custom CSS styling.
            Integrated the TMDB API to fetch and display categorized content by genre,
            featuring a functional search engine for seamless navigation. Enhanced user experience by showcasing key details like production year, ratings, cast, revenue, budget and plot summaries.`,
    tags: ["React", "RESTful API", "CSS", "Axios", "React Router"],
    codeLink: "https://github.com/Koteskidavor/Movies",
    liveLink: "https://movies-46733.web.app/",
    route: "Movies",
  },
  {
    name: "Dreamsnap",
    image: dreamsnap,
    creator: "Davor Koteski",
    date: "Dec 20, 2024",
    description: `This React.js project uses plain CSS and an HTML5 Canvas-powered starfield background. 
    It integrates the HuggingFace API with Flux.1 [dev] to generate unique images.`,
    tags: ["React", "RESTful API", "CSS", "MUI"],
    codeLink: "https://github.com/Koteskidavor/Dreamsnap",
    liveLink: "https://dreamsnap-78f5e.web.app/",
    route: "Dreamsnap",
  },
];

export const socials = [
  {
    label: "Github",
    icon: <GitHubIcon />,
    link: "https://github.com/Koteskidavor",
    ariaLabel: `Visit Davor Koteski's GitHub profile`,
  },
  {
    label: "LinkedIn",
    icon: <LinkedInIcon />,
    link: "https://www.linkedin.com/in/davor-koteski/",
    ariaLabel: `Visit Davor Koteski's LinkedIn profile`,
  },
  {
    label: "Email",
    icon: <EmailIcon />,
    link: "/Contact",
    ariaLabel: "My contact Information",
  },
];

export const routes = ["/", "/About", "/Portfolio", "/Contact"];

export const menuNav = [
  { Icon: Home, label: "Home", link: "/" },
  {
    Icon: User,
    label: "About Me",
    link: "/About",
  },
  { Icon: Briefcase, label: "Portfolio", link: "/Portfolio" },
  {
    Icon: Mail,
    label: "Contact",
    link: "/Contact",
  },
];

export const mainVariant = {
  initial: { y: "-100%", opacity: 0 },
  animate: { y: 0, opacity: 1, transition: { duration: 0.5, ease: "easeOut" } },
  exit: {
    y: "-100%",
    opacity: 0,
    transition: { duration: 0.5, ease: "easeIn" },
  },
};
export const aboutVariant = {
  initial: {
    y: -50, rotateY: 90, transformOrigin: "center", transformPerspective: 1200
  },
  animate: {
    y: 0,
    rotateY: 0,
    transformPerspective: 1200,
    transition: { duration: 0.5, ease: "easeOut" },
  },
  exit: {
    y: -50,
    rotateY: 90,
    transformPerspective: 1200,
    transition: { duration: 0.5, ease: "easeIn" },
  },
};
export const portfolioVariant = {
  initial: {
    x: "-100%",
    opacity: 0
  },
  animate: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.5, ease: "easeOut" }
  },
  static: {
    opacity: 1,
    x: 0, transition: { duration: 0 }
  },
};
export const contactVariant = {
  initial: {
    opacity: 0,
    rotateY: 90,
    scale: 0.8,
    transformOrigin: "right center",
  },
  animate: {
    opacity: 1,
    rotateY: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut",
      type: "spring",
      stiffness: 120,
      damping: 12,
    },
  },
  exit: {
    opacity: 0,
    rotateY: -90,
    scale: 0.9,
    transition: {
      duration: 0.6,
      ease: "easeInOut",
    },
  },
};

